// import Auth0Lock from "auth0-lock";
// import history from "./history";
// import { AUTH0_CONFIG } from "../config/auth-lock0.config";
// const DEFAULT_ROUTE = "/";
export default class Session {
  //   constructor() {
  //     this.lock = new Auth0Lock(AUTH0_CONFIG.clientId, AUTH0_CONFIG.domain, {
  //       allowSignUp: false,
  //       languageDictionary: { title: "PostBox" },
  //       language: "en",
  //       theme: {
  //         logo: "https://image.flaticon.com/icons/svg/183/183186.svg",
  //         primaryColor: "#cc584c"
  //       },
  //       auth: {
  //         redirectUrl: "/",
  //         responseType: "token id_token",
  //         params: {
  //           scope: "openid"
  //         }
  //       }
  //     });
  //     this.lock.on("authenticated", authResult => {
  //       this.lock.getUserInfo(authResult.accessToken, function(error, profile) {
  //         if (error) {
  //           history.replace(DEFAULT_ROUTE);
  //           console.log(error); //eslint-disable-line no-console
  //           alert(
  //             `Error: ${error.error}. Check the console for further details.`
  //           );
  //           return;
  //         }
  //         if (authResult && authResult.accessToken && authResult.idToken) {
  //           const expiresAt = JSON.stringify(
  //             authResult.idTokenPayload.exp * 1000
  //           );

  //           localStorage.setItem("access_token", authResult.accessToken);
  //           localStorage.setItem("id_token", authResult.idToken);
  //           localStorage.setItem("expires_at", expiresAt);

  //           localStorage.setItem(
  //             "user",
  //             JSON.stringify({
  //               userId: profile.user_id,
  //               picture: profile.picture,
  //               email: profile.email,
  //               nickname: profile.nickname,
  //               accountId: "n65n3pqx" //TODO: remove hard coded accountId
  //             })
  //           );
  //           // navigate to the root route
  //           history.replace(DEFAULT_ROUTE);
  //         }
  //       });
  //     });
  //   }
  login() {
    //this.auth0.authorize();
    this.lock.show();
  }
  static isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  }

  static getItem(key) {
    return localStorage.getItem(key);
    // return sessionStorage.getItem(key);
  }
  static setItem(key, value) {
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  }

  static logout() {
    // Clear access token and ID token from local storage
    // localStorage.removeItem("access_token");
    // localStorage.removeItem("id_token");
    // localStorage.removeItem("expires_at");
    // localStorage.removeItem("user");
    // navigate to the root route
    // history.replace(DEFAULT_ROUTE);
    localStorage.removeItem(Session.MM_CUSTOMER_ID)
    localStorage.removeItem(Session.CURRENT_USER_NAME)
    localStorage.removeItem(Session.CURRENT_NAME)
    localStorage.removeItem(Session.CURRENT_USER_ID)
    sessionStorage.clear();
  }
  //Session Related variables
  static MM_CUSTOMER_ID = "current_mmcustomerid";
  static CURRENT_USER_NAME = "current_username";
  static CURRENT_NAME = "current_name";
  static CURRENT_USER_ID = "current_userId";
}



// WEBPACK FOOTER //
// ./src/utility/session.js